import { useState } from 'react'

import { areAllRequiredFieldsFilledAntdV4 } from '~/lib/formHelpers'

/**
 * Use this hook whenever you have a "disabled submit button" pattern.
 *
 * Because form errors don't show up until after a field is filled out, you need to check that all required form fields are filled
 * AND that all form fields don't have errors.
 *
 * This hook also reveals the active formValues.
 *
 * @param requiredFields array of required field names
 *
 * Set the returned object attributes onFieldsChange and onValuesChange as props to the <Form> element.
 */
export const useDisabledFormSubmitButton = (requiredFields: string[]) => {
    const [formValues, setFormValues] = useState<Record<string, string>>({})
    const [requiredFieldsFilled, setRequiredFieldsFilled] = useState(false)
    const [formHasErrors, setFormHasErrors] = useState(true)

    const onFieldsChange = async (_: any, allFields: any[]) => {
        const hasErrors = allFields.some((field: any) => field.errors.length)

        setFormHasErrors(hasErrors)
    }

    const onValuesChange = (_: any, allValues: any) => {
        setFormValues(allValues)
        const allRequiredFieldsFilled = areAllRequiredFieldsFilledAntdV4(
            allValues,
            requiredFields,
        )

        setRequiredFieldsFilled(allRequiredFieldsFilled)
    }

    const disableFormSubmitButton = !requiredFieldsFilled || formHasErrors

    return {
        onFieldsChange,
        onValuesChange,
        disableFormSubmitButton,
        formValues,
    }
}
